import React from 'react';
import { Clock, MapPin, Users } from 'lucide-react';
import type { Event } from '@/types/event';

interface EventStatsProps {
  event: Event;
  participants?: number;
  isFeatured?: boolean;
  category?: string;
}
const EventStats = ({ event }: EventStatsProps) => {
  return (
    <div className="flex flex-wrap items-center text-sm sm:text-base lg:text-lg text-gray-400 gap-3 sm:gap-4">
      <div className="flex items-center">
        <Clock size={12} className="sm:w-3 sm:h-3 md:w-4 md:h-4 mr-1 text-orange-500 flex-shrink-0" />
        <span className="whitespace-nowrap">
          {new Date(event.event_date as string).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
        </span>
      </div>
      <div className="flex items-center">
        <MapPin size={12} className="sm:w-3 sm:h-3 md:w-4 md:h-4 mr-1 text-orange-500 flex-shrink-0" />
        <span className="truncate max-w-[120px] sm:max-w-[150px] md:max-w-none">
          {event.address?.venue || event.location || "Online"}
        </span>
      </div>
      <div className="flex items-center">
        <Users size={12} className="sm:w-3 sm:h-3 md:w-4 md:h-4 mr-1 text-orange-500 flex-shrink-0" />
        <span className="whitespace-nowrap">
          {event.registrations_count || "0"} registered
        </span>
      </div>
    </div>
  );
};

export default EventStats;